// extracted by mini-css-extract-plugin
module.exports = {"buttons":"pricingButtons-module--buttons--FjNX2","inactive":"pricingButtons-module--inactive--zJeiu","currenciesWrapper":"pricingButtons-module--currenciesWrapper--2caQW"};